import { TinyDropdownMenu } from '@octopus-do/octopus-storybook'
import { Envelope } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

export const Content: React.FC = () => (
  <TinyDropdownMenu.Group>
    <TinyDropdownMenu.Button
      id="mark-unread"
      label="Mark as unread"
      icon={Envelope}
    />
  </TinyDropdownMenu.Group>
)
